import { Button, Typography } from "@mui/material";
import React from "react";

function AiAvatarIntroduction({ onNext }) {
    return (
        <div style={{ padding: "10px" }}>
            <Typography variant="highlightSemibold">
                Create AI Avatar
            </Typography>
            <br />
            <Typography variant="supportRegular">
                Now creating an avatar using AI is so easy and fun. Go through
                the steps given below and you were all set to create avatar
                using AI prompt
            </Typography>
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 1 - Upload Images{" "}
            </Typography>
            <br />
            <Typography variant="captionEmphasis">
                You will be asked to upload 50 images with different angle so
                that AI will create your avatar for any situation. So keep them
                ready when processing. Please provide clear and high resolution
                images for better and realistic results. To know more about the
                images Click Here
            </Typography>{" "}
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 2 - Image Modelling{" "}
            </Typography>{" "}
            <br />
            <Typography variant="captionEmphasis">
                Once you upload all 50 images click on continue and AI will
                start modelling your images to create your avatar. This can take
                up to 20 minutes to complete. Please wait until AI finishes
                modelling or you can leave the page and modelling will continue
                in background. We will notify you once modelling is done.
            </Typography>{" "}
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 3 - Generate Images{" "}
            </Typography>{" "}
            <br />
            <Typography variant="captionEmphasis">
                Once modelling is done you will be taken to AI command prompt
                section. where you can ask AI to generate situation based
                avatar. i. e. “Create my avatar which is looking at moon sitting
                on top of the mountain” and hit enter.
            </Typography>{" "}
            <br /> <br />
            <Typography variant="contentEmphasis">
                Step 4 - Boom! Enjoy your avatar{" "}
            </Typography>{" "}
            <br />
            <Typography variant="captionEmphasis">
                Yay!!! enjoy your AI avatar. You can download jpg, png, pdf. You
                can create up to 10 avatars per day.
            </Typography>{" "}
            <br /> <br />
            {/* Your introduction content here */}
            <Button
                variant="contained"
                sx={{ width: "25%", marginTop: "3rem", marginBottom: "2rem" }}
                onClick={onNext}
            >
                Continue
            </Button>
        </div>
    );
}
export default AiAvatarIntroduction;
